<div [attr.data-e2e]="e2eId">
  <h2 [idOrDefault]="titleId" *ngIf="title">{{ title }}</h2>
  <p [idOrDefault]="leadTextId" *ngIf="leadText">
    <span [innerHTML]="leadText"></span>
    <a
      [attr.data-e2e]="E2e.ReadMoreLink"
      (click)="toggleReveal()"
      *ngIf="readMoreText"
      >{{ readMoreText }}
    </a>
  </p>
  <div class="group-margin" *ngIf="reveal$ | async" [@enter] [@leave]>
    <h4
      [attr.data-e2e]="E2e.RevealTitle"
      class="option-reveal-title"
      *ngIf="revealTitle"
    >
      {{ revealTitle }}
    </h4>
    <div
      [attr.data-e2e]="E2e.RevealContent"
      class="option-reveal-content"
      *ngIf="revealContentHtml"
      [innerHtml]="revealContentHtml"
    ></div>
  </div>
  <div class="group-margin"><ng-content></ng-content></div>
  <div class="option-detail" *ngIf="showPrice$ | async">
    <span class="price-label" *ngIf="optionDetailLabel">
      {{ optionDetailLabel }}
    </span>
    <div
      id="price-container"
      class="price price--optional"
      *ngIf="optionDetailPrice"
    >
      <span id="price-amount" [attr.data-e2e]="E2e.Price" class="price-amount">
        + {{ optionDetailPrice | tvlCurrency: currencyCode }}
      </span>
      <nibtravel-link-icon
        spacing="space-right"
        [icon]="icon.Trash"
        [iconPosition]="position.Start"
        [linkText]="'Remove'"
        (linkClicked)="onRemovedOption($event)"
      ></nibtravel-link-icon>
    </div>
  </div>
</div>
